var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-card",
    [
      _c("h3", [_vm._v(_vm._s(_vm.subjectName))]),
      _c(
        "div",
        { staticClass: "unfold-button-container" },
        [
          _c("h4", [_vm._v("Alertas activadas: " + _vm._s(_vm.totalAlerts))]),
          _vm.changes
            ? _c("p", { staticClass: "changes" }, [
                _vm._v("Hay cambios sin guardar"),
              ])
            : _vm._e(),
          _c("el-button", {
            staticClass: "unfold-button",
            attrs: { icon: _vm.unfoldButtonIcon },
            on: { click: _vm.onClickUnfolder },
          }),
        ],
        1
      ),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.configurationLoading,
              expression: "configurationLoading",
            },
          ],
          ref: "form",
          attrs: { model: _vm.form },
        },
        [
          _vm._l(_vm.form, function (value, key) {
            return _c(
              "el-form-item",
              { key: key, staticClass: "item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "option-container",
                    on: {
                      click: function ($event) {
                        return _vm.onClickItem(key)
                      },
                    },
                  },
                  [
                    _c("h4", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.mainOptions[key])),
                    ]),
                    !_vm.showOptions[key]
                      ? _c("i", { staticClass: "el-icon-arrow-down" })
                      : _vm._e(),
                    _vm.showOptions[key]
                      ? _c("i", { staticClass: "el-icon-arrow-up" })
                      : _vm._e(),
                  ]
                ),
                _c("Alerts-MenuItem", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showOptions[key],
                      expression: "showOptions[key]",
                    },
                  ],
                  attrs: {
                    name: _vm.mainOptions[key],
                    options: value,
                    form: _vm.form,
                    group: key,
                  },
                }),
                key === "sendEmail"
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showOptions[key],
                            expression: "showOptions[key]",
                          },
                        ],
                        staticClass: "mail-switch",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "mail-switch" },
                          [
                            _c("div", { staticClass: "option-name" }, [
                              _vm._v("Enviar Email"),
                            ]),
                            key === "sendEmail"
                              ? _c("el-switch", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showOptions[key],
                                      expression: "showOptions[key]",
                                    },
                                  ],
                                  attrs: { label: "Enviar" },
                                  model: {
                                    value: _vm.form[key],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, key, $$v)
                                    },
                                    expression: "form[key]",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          _c("el-form-item", [
            _c("div", { staticClass: "button-container" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.configurationLoading,
                          expression: "configurationLoading",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("Guardar")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.configurationLoading,
                          expression: "configurationLoading",
                        },
                      ],
                      on: { click: _vm.onCancel },
                    },
                    [_vm._v("Cancelar")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.configurationLoading,
                          expression: "configurationLoading",
                        },
                      ],
                      on: { click: _vm.onActivate },
                    },
                    [_vm._v("Activar todas")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.configurationLoading,
                          expression: "configurationLoading",
                        },
                      ],
                      on: { click: _vm.onDesactivate },
                    },
                    [_vm._v("Desactivar todas")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }